<template>
  <router-link
    tag="a"
    :to="$store.getters['main/getSingleUrl'](data)"
    class="video-card"
  >
    <div class="img-box">
      <div class="mask"></div>
      <div class="play-svg">
        <IconComponent name="play" />
      </div>
      <img :src="getThumbnail" />
    </div>
    <h3 class="font-21">
      {{ data.title }}
    </h3>
  </router-link>
</template>
<script>
import IconComponent from "../IconComponent.vue";
export default {
  props: ["data"],
  components: {
    IconComponent
  },
  computed: {
    getThumbnail() {
      var iframes = _.get(this.data, "content");
      var res;

      res = iframes.split("?");
      res = res[0].split("/");
      res = res.pop();

      return `https://img.youtube.com/vi/${res}/hqdefault.jpg`;
    }
  }
};
</script>
<style lang="scss">
.video-card {
  width: 100%;
  &:hover {
    .img-box {
      img {
        transform: scale(1.1);
      }
    }
  }
  .img-box {
    .mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: var(--secondary);
      opacity: 0.3;
      z-index: 3;
    }
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    position: relative;
    padding-top: 56.5%;
    // background: var(--secondary);
    margin-bottom: 34px;
    overflow: hidden;
    .play-svg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 4;
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        rect {
          fill: var(--media-bg);
        }
      }
    }
    .img-absolute {
      opacity: 0.7;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      will-change: transform;
    }
  }
  h3 {
    color: var(--bonus-txt);
  }
  &:hover {
    h3 {
      color: var(--primary-txt);
    }
  }
}
</style>
